module.exports = __webpack_public_path__ + "img/Author_XueMou_YiLi.808f99c7.png";